import React from "react";
import PropTypes from "prop-types";
import ContentSection from "components/common/content-section";
import "./angle.scss";

function Angle({
  children,
  containerCss,
  color,
  bgColor,
  contentPadding,
  ...rest
}) {
  return (
    <div className={`angle-content-fx ${containerCss}`}>
      <section className="top-angle">
        <div className="svg-art-container">
          <svg
            className="svg-art"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            style={{ backgroundColor: bgColor }}
          >
            <path d="M-10,100 L100,70 100,100 Z" fill={color}></path>
          </svg>
        </div>
      </section>
      <ContentSection
        {...rest}
        specificClass="content-container"
        containerStyle={{ backgroundColor: color }}
        padding={contentPadding}
      >
        {children}
      </ContentSection>
      <section className="bottom-angle">
        <div className="svg-art-bottom-container">
          <svg
            className="svg-art-bottom"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            style={{ backgroundColor: color }}
          >
            <path d="M-10,100 L100,70 100,100 Z" fill={bgColor}></path>
          </svg>
        </div>
      </section>
    </div>
  );
} // fill="#ffffff" fill={color}

Angle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  containerCss: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  contentPadding: PropTypes.string, // Bootstrap padding, valid values:  "0, 1, 2, 3, 4, 5"
};

Angle.defaultProps = {
  data: {},
  containerCss: "",
  color: "#f7f8f9",
  bgColor: "#fff",
  contentPadding: "5",
};

export default Angle;
